import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { LogoCarousel } from '../components/landing/LogoCarousel';
import { Work } from '../components/landing/Work';
import { Services } from '../components/landing/Services';
import { About } from '../components/landing/About';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full overflow-x-hidden" style={{
    background: 'var(--bg)',
    color: 'var(--fg)'
  }} data-id="element-273">
      <Navbar data-id="element-274" />
      <Hero data-id="element-275" />
      <LogoCarousel data-id="element-276" />
      <Work data-id="element-277" />
      <Services data-id="element-278" />
      <About data-id="element-279" />
      <Footer data-id="element-280" />
    </div>;
}